//#region src/core/ids.ts
function e() {
	return typeof globalThis < "u" ? globalThis.crypto : void 0;
}
function t(e) {
	e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
	let t = [];
	for (let e = 0; e < 256; e++) t.push((e + 256).toString(16).slice(1));
	let n = e;
	return t[n[0]] + t[n[1]] + t[n[2]] + t[n[3]] + "-" + t[n[4]] + t[n[5]] + "-" + t[n[6]] + t[n[7]] + "-" + t[n[8]] + t[n[9]] + "-" + t[n[10]] + t[n[11]] + t[n[12]] + t[n[13]] + t[n[14]] + t[n[15]];
}
function n() {
	let n = e();
	if (n && typeof n.randomUUID == "function") return n.randomUUID();
	if (n && typeof n.getRandomValues == "function") return t(n.getRandomValues(new Uint8Array(16)));
	let r = new Uint8Array(16);
	for (let e = 0; e < 16; e++) r[e] = Math.floor(Math.random() * 256);
	return t(r);
}
//#endregion
export { n as uuid };
